import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';

import { Store } from '@ngrx/store';

import { AppState, getMyUtenti } from 'src/app/store/app.state';
import { Resource } from '../../models/resource.model';
import { UtilityService } from '../../services/utility.service';
import { Utente } from '../../models/utente.model';
import { StartRemoveUserResource } from 'src/app/utenti/store';
import { SubSink } from 'subsink';

/**Componente del modale di gestione risorse assegnate a un utente */
@Component({
  selector: 'app-modale-risorse',
  templateUrl: './modale-risorse.component.html',
  styleUrls: ['./modale-risorse.component.css']
})
export class ModaleRisorseComponent implements OnInit, OnDestroy {
  private subs = new SubSink();
  /**Emettitore dell'evento di chiusura */
  @Output() close = new EventEmitter<void>();

  /**Lista dei trattati disponibili */
  tractatesList: Resource[];
  /**Lista delle risorse assegnate all'utente */
  assignedList: Resource[];

  selectedUser: Utente;

  /**Opzioni della scrollbar */
  options = {autoHide: false, scrollbarMinSize: 100};

  /**
   * Costruttore della classe ModaleRisorseComponent
   * @param store {Store<AppState>} stato a livello dell'applicazione
   */
  constructor(
    private store: Store<AppState>,
    private utility: UtilityService
  ) { }

  /**Metodo dell'interfaccia OnInit che utilizzo per recuperare dati dallo stato */
  ngOnInit() {
    this.subs.sink = this.store.select(getMyUtenti).subscribe(
      data => {
        this.tractatesList = data.elencoTrattati? data.elencoTrattati.slice(): [];
        this.assignedList = data.elencoRisorse ? data.elencoRisorse.slice() : [];
        this.selectedUser = data.utenteSelezionato;
      }
    )
  }

  /**
   * Metodo che chiama l'utility per il recupero del titolo del trattato padre di una risorsa
   * @param risorsa {Resource} risorsa corrente
   * @returns string
   */
  getTractateTitle(risorsa: Resource) {
    return this.utility.getTractateTitle(risorsa, this.tractatesList);
  }

  onRemoveAssignedResource(idRisorsa: number): void {
    this.store.dispatch(new StartRemoveUserResource({userId: this.selectedUser.id, resourceId: idRisorsa}));
  }

  /**Metodo che emette l'evento di chiusura al click sullo sfondo o sul pulsante relativo*/
  onClose() {
    this.close.emit();
  }  

  trackByFn(index: number, item: Resource): number {
    return item.id;
  }

  /**Metodo dell'interfaccia OnDestroy con il quale rimuovo eventuali sottoscrizioni */
  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
